export const getDateString = (date) => {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    const dateString = `${day}-${month}-${year}`;
    return dateString;
};
